import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SectionReveal from "@/components/effects/SectionReveal";
import { STACK_GROUPS } from "@/data/content";
import { TID } from "@/constants/testIds";

const Stack = () => {
    const [active, setActive] = useState(STACK_GROUPS[0].label);
    const current = STACK_GROUPS.find((g) => g.label === active) || STACK_GROUPS[0];

    return (
        <section id="stack" className="relative py-24 md:py-40">
            <div className="container-x">
                <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
                    <SectionReveal>
                        <p className="overline">05 — Technology</p>
                        <h2
                            className="mt-4 text-3xl font-medium tracking-tight text-white sm:text-4xl md:text-5xl"
                            style={{ fontFamily: "'General Sans', sans-serif" }}
                        >
                            The stack I work in.
                        </h2>
                    </SectionReveal>
                    <SectionReveal delay={0.15}>
                        <p className="max-w-md text-sm text-brand-muted md:text-base">
                            Tools change every year. Principles don&apos;t. Below are the ones I choose today because they
                            help clients ship faster and grow further.
                        </p>
                    </SectionReveal>
                </div>

                <div className="mt-12 flex flex-wrap gap-2">
                    {STACK_GROUPS.map((g) => (
                        <button
                            key={g.label}
                            data-testid={TID.stackTab(g.label)}
                            onClick={() => setActive(g.label)}
                            className={`inline-flex h-10 items-center rounded-full border px-4 text-sm font-medium transition-all ${
                                active === g.label
                                    ? "border-white/25 bg-white/[.08] text-white"
                                    : "border-white/[.08] bg-white/[.02] text-brand-muted hover:border-white/20 hover:text-white"
                            }`}
                        >
                            {g.label}
                        </button>
                    ))}
                </div>

                <div className="mt-8 min-h-[260px] overflow-hidden rounded-3xl border border-white/[.08] bg-[#0a0a0a] p-8 md:p-12">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={current.label}
                            initial={{ opacity: 0, y: 12 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -8 }}
                            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                            className="flex flex-wrap gap-3"
                        >
                            {current.items.map((item, i) => (
                                <motion.span
                                    key={item}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{
                                        duration: 0.5,
                                        delay: i * 0.04,
                                        ease: [0.16, 1, 0.3, 1]
                                    }}
                                    className="inline-flex h-11 items-center gap-2 rounded-full border border-white/[.08] bg-white/[.03] px-5 text-sm font-medium text-white transition-colors hover:border-brand-primary/50 hover:text-brand-primary"
                                >
                                    <span className="h-1.5 w-1.5 rounded-full bg-brand-primary" />
                                    {item}
                                </motion.span>
                            ))}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </section>
    );
};

export default Stack;
